import { ReactNode, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { setIsOffline } from '../store/slices/appStatusSlice';
import { ErrorScreen } from './ui/ErrorScreen/ErrorScreen';

type AppStatusGateProps = {
  children: ReactNode;
};

export function AppStatusGate({ children }: AppStatusGateProps) {
  const dispatch = useAppDispatch();
  const isOffline = useAppSelector((state) => state.appStatus.isOffline);

  useEffect(() => {
    const updateOnlineStatus = () => {
      dispatch(setIsOffline(!navigator.onLine));
    };

    updateOnlineStatus();

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, [dispatch]);

  if (isOffline) {
    return <ErrorScreen variant="offline" />;
  }

  return <>{children}</>;
}
